/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CommitId } from "../../commons/types/CommitId";
import { SheetId } from "../../commons/types/SheetId";
export const Commit = core.serialization.object({
    id: CommitId,
    sheetId: SheetId,
    createdBy: core.serialization.string(),
    completedBy: core.serialization.string().optional(),
    createdAt: core.serialization.date(),
    completedAt: core.serialization.date().optional(),
});
